<script setup lang="ts">
import { pascalCase } from 'scule'
import { resolveComponent } from 'vue'
import type { Schemas } from '#shopware'

useRouteCache((helper) => {
    helper.setMaxAge(60).setCacheable()
})

const { resolvePath } = useNavigationSearch()
const route = useRoute()
const { t, locale } = useI18n()
const config = useRuntimeConfig()
const routePath = route.path.replace(`${locale.value}`, '').replace('//', '/')

const { data: seoResult } = await useAsyncData(
    `cmsResponse${routePath}`,
    async () => {
        return resolvePath(routePath)
    },
)

if (!seoResult.value?.seoUrl?.foreignKey) {
    console.error('index.vue:', `No data found in API for ${routePath}`)

    throw createError({
        status: 404,
        statusText: `No data fetched from API for ${routePath}`,
    })
}

const { routeName, foreignKey } = useNavigationContext(
    seoResult.value.seoUrl as unknown as Ref<Schemas['SeoUrl']>,
)

const pageComponent = computed(() => {
    return resolveComponent(pascalCase(routeName.value as string))
})

// Get shop-specific meta key based on theme
const theme = config.public.theme as string
const metaKeyMap: Record<string, string> = {
    'gisy': 'meta',
    'juppen': 'metaJuppen',
    'prange': 'metaPrange'
}
const metaKey = metaKeyMap[theme] || 'meta'


useSeoMeta({
    title: t(`${metaKey}.home.title`),
    description: t(`${metaKey}.home.content`),
    robots: 'INDEX, FOLLOW'
})

const runtimeConfig = useRuntimeConfig()
const storefrontUrl = runtimeConfig.public.shopware?.devStorefrontUrl || useRequestURL().origin
const structuredDataLogo = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "url": storefrontUrl,
    "logo": storefrontUrl + "/logo.png"
};

useHead({
    script: [
        {
            type: 'application/ld+json',
            innerHTML: structuredDataLogo
        }
    ]
})
</script>

<template>
    <component :is="pageComponent" v-if="pageComponent" :navigation-id="foreignKey" />
</template>
